export default "__VITE_ASSET__Bgd1QHPP__"